import { render, staticRenderFns } from "./ItemTabRelatedItems.vue?vue&type=template&id=557ae87b&scoped=true"
import script from "./ItemTabRelatedItems.vue?vue&type=script&lang=ts"
export * from "./ItemTabRelatedItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ae87b",
  null
  
)

export default component.exports